import React, {useEffect, useState} from "react";
import {Monitor} from "lucide-react";
import {useTranslation} from "react-i18next";
import {api} from "../../../config/api";
import secureStorage from "../../../utils/secureStorage";
import AppleSelect from "../../Common/AppleSelect";

// Filtre « par caisse » des listes Ventes / Journaux. La caisse = nom donné
// sur la POS (Réglages > Mon matériel), copié sur chaque journal ; une vente
// appartient à la caisse de son journal. Valeur '' = toutes les caisses,
// REGISTER_NONE = journaux d'une caisse sans nom (tout l'historique d'avant).
// Toujours affiché : sans caisse nommée (ou API pas encore à jour), seules
// « Toutes les caisses » et « Caisse sans nom » sont proposées.
export const REGISTER_NONE = "__none__";

const RegisterSelect = ({value, onChange, className = ""}) => {
    const {t} = useTranslation("activite");
    const [registers, setRegisters] = useState([]);
    const [hasUnnamed, setHasUnnamed] = useState(true);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const account = await secureStorage.getItem("selectedAccount");
                if (!account?.id) return;
                const res = await api.get("/activite/registers", {
                    headers: {"X-account-id": account.id, "Accept": "application/json"},
                });
                if (cancelled) return;
                setRegisters(res.data?.registers || []);
                setHasUnnamed(!!res.data?.hasUnnamed || !(res.data?.registers || []).length);
            } catch (e) {
                // API pas encore à jour : seules « Toutes » et « Sans nom ».
                if (!cancelled) setRegisters([]);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, []);

    // Cellule de barre d'outils (AppleSelect variant="toolbar"), même rendu que
    // les filtres du Stock / des Retours à côté d'un SearchInput.
    return (
        <div className={`flex min-w-0 ${className}`}>
            <AppleSelect
                variant="toolbar"
                icon={Monitor}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                title={t("registers.label")}
                aria-label={t("registers.label")}
                options={[
                    {value: "", label: t("registers.all")},
                    ...registers.map((name) => ({value: name, label: name})),
                    ...(hasUnnamed ? [{value: REGISTER_NONE, label: t("registers.none")}] : []),
                ]}
            />
        </div>
    );
};

export default RegisterSelect;
